import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Button, Modal } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import numeral from 'numeral'
import 'numeral/locales'

const language = (playmotiv.locale || 'es-es').replace('_', '-');
numeral.locale(language);

try {
  numeral(1000).format('0,0');
} catch (e) {
  // no existe el language en la libraria
  // se puede definir o incluir de algun otro sitio??
  numeral.locale('es-es');
}

import { LoadingIndicator } from 'basecomps'
import { useGame, useRanking, useRankingData } from 'data/hooks'

import { Podium } from './podium'
import { Item } from './item'

export const Ranking = props => {

  // valores por defecto
  const params = useParams()
  const gameId = useParams().gameId || playmotiv.game.gameId
  const eventId = params.eventId || props.eventid
  const game = useGame(gameId)
  const { kpis } = useGame(gameId)
  const rankingId = (props?.attribs || {})["data-rankingid"] ||
                    params.rankingId || 
                    props.rankingid

  const { ranking } = useRanking(gameId, rankingId, eventId) 
  const { list, refresh } = useRankingData(gameId, rankingId, eventId)
  const [ kpi, setKpi ] = useState()

  const { showMenuInstances } = props || false
  const hideReload = props.hideReload || false
  const type = (props?.attribs || {})["data-type"] ||
                props.type || 'ranking'
  const allowDetail = (props?.attribs || {})["data-allowdetail"] === "true" ||
                      props.allowDetail || false

  const [ detailVisible, showDetail ] = useState(false)

  const getKpi = () => ranking ? kpis[ranking.kpi] : kpis[props.kpi]

  useEffect(() => {
    refresh()
  }, [ranking])


  /*
  useEffect(() => {

    let kpi
    console.log(ranking)

    if (!ranking) {

      kpi = kpis[props.kpi] // Case there is no ranking for user in events

    } else {

      kpi = kpis[ranking.kpi]

    }

    console.log(kpi)
    setKpi(kpi)

    refresh()

  }, [ranking])
  */

  const formatValue = value => {

    const kpi = getKpi()

    if (!kpi?.mask) console.log('no hay mascara ...')

    const formatedValue = value ?
      kpi?.mask ? numeral(parseFloat(value)).format(kpi.mask)
        : value
      : ''
    return formatedValue
  }
  
  return <>
    { 
      ( ranking || props.kpi )
      && 
      list ?
      <div className="ranking-wrapper">

        <Modal 
          className="ranking-modal"
          open={detailVisible}
          onCancel={() => showDetail(false)}
          footer= {false}
        >          
          <Ranking rankingId={rankingId} type="ranking" showDetail={false} hideReload={true} />
        </Modal>

        <div className="header">
          <div className="title">
            {props.header && props.header.left ? props.header.left : <></>}
            { 
              ranking ? 
                ranking.title 
                : 
                props.title ? 
                  props.title 
                  : 
                  rankingId.split('_').map(w => w.capitalize()).join(' ')
            }
            {props.header && props.header.right ? props.header.right : <></>}
          </div>
            { 
              !hideReload && 
              <div className="tools">
                <Button onClick={refresh} icon={<ReloadOutlined />} />
              </div>
            }
        </div>
        
        <div 
          className={`
            ranking
            ${ props.className || '' }
          `}>

          <Podium gameId={gameId} list={list} formatValue={formatValue} />

          { type === 'ranking' && 
            <div className="list-wrapper">
              <div className="item header">
                <div className="position" />
                <div className="avatar" />
                <div className="user-name" />
                {
                  props.legend ?
                  props.legend
                  :
                  <div className="value">{getKpi()?.title}</div>
                }
              </div>
              {
                list.map((item, index) =>
                  <Item
                    key={index}
                    gameId={gameId}
                    {...item}
                    formatValue={formatValue}
                    { ...props }
                  />)
              }
            </div>
          }
          { type === 'podium' && allowDetail && 
            <Button type="link" onClick={() => showDetail(true)}>Ver detalle</Button>
          }
        </div>

      </div>

      : 
      
      <LoadingIndicator text="Cargando ranking ..." />
    }
  </>
}
